<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content ui basic segment" [class.loading]="geofenceProfileLoading">
  <div class="scroll-wrapper ui basic segment">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    <ng-container *ngFor="let profile of geofenceProfile; let i = index">
      <h4>Geofence Profile {{ i + 1 }}</h4>
      <div class="column" fxLayout="column">
        <div fxFlex><strong>Profile Name</strong></div>
        <div fxFlex>{{ profile?.profileName }}</div>
      </div>
      <div class="column" fxLayout="column">
        <div fxFlex><strong>Countries</strong></div>
        <div fxFlex>{{ profile?.countries }}</div>
      </div>
      <div class="column" fxLayout="column">
        <div fxFlex><strong>Date Assigned</strong></div>
        <div fxFlex>{{ profile?.dateCreated | date }}</div>
      </div>
      <div class="column" fxLayout="column">
        <div fxFlex><strong>Assigned By</strong></div>
        <div fxFlex>{{ profile?.createdBy | createdBy }}</div>
      </div>
      <hr />
    </ng-container>

    <div style="position: absolute; bottom: 0" class="actions">
      <button class="ui basic primary button" (click)="modal.deny(undefined)">
        Cancel
      </button>
    </div>
  </div>
</div>
